export default {
  product_info: 'Info do Produto',
  return: 'Voltar às opções',
};
